import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'relative',
    marginBottom: '20px',
  },
  btnAdd: {
    textTransform: 'capitalize',
    boxShadow: theme.shadows[0],
    padding: theme.spacing(2, 2),
    marginLeft: theme.spacing(2),
    minWidth: 64,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#5081FF',
    borderRadius: 4,
    '&:hover': {
      backgroundColor: 'rgb(0, 87, 178)',
      boxShadow:
        '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
    },
    '& svg': {
      fill: '#ffffff',
    },
  },
  dropdown: {
    position: 'absolute',
    zIndex: 1,
    top: 40,
    right: 0,
    width: 270,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0px 6px 6px rgba(0, 0, 0, 0.26), 0px 10px 20px rgba(0, 0, 0, 0.19)',
    borderRadius: 4,
  },
  selectItem: {
    padding: theme.spacing(1, 1.2),
    '& svg': {
      marginRight: theme.spacing(1.2),
    },
    '& img': {
      marginRight: theme.spacing(1.2),
    },
  },
  value: {
    fontSize: 34,
    marginBottom: theme.spacing(1),
  },

  yesValue: {
    fontSize: 20,
  },
  title: {
    flexGrow: 1,
    maxWidth: 280,
    //height: 60,
    fontSize: 16,
    marginBottom: theme.spacing(3),
    color: '#757575',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
  },
  gridPaper: {
    height: '140px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'relative',
    padding: '16px',
    boxSizing: 'border-box',
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  infoContainer: {
    display: 'flex',
    marginBottom: theme.spacing(1),
    alignItems: 'stretch',
  },
  link: {
    display: 'inline-block',
    textTransform: 'uppercase',
    color: theme.palette.info.main,
    letterSpacing: 0.4,
    fontSize: 14,
    //marginLeft: theme.spacing(1),
    //fontWeight: 600,
    margin: `0 ${theme.spacing(3)}px 0 0`,
  },
  // paper: {
  //   marginTop: theme.spacing(2),
  //   backgroundColor: '#ffffff',
  //   padding: theme.spacing(3),
  //   boxShadow: theme.shadows[0],
  //   width: '100%',
  //   marginBottom: theme.spacing(2),
  // },
  //  container: {
  //     paddingTop: theme.spacing(2),
  //     paddingBottom: theme.spacing(4),
  //   },
  //       infoContainer: {
  //     display: 'flex',
  //     marginBottom: theme.spacing(1),
  //     //height: '20%',
  //   },
  //       title: {
  //     flexGrow: 1,
  //     maxWidth: 280,
  //     //height: 60,
  //     fontSize: 16,
  //     marginBottom: theme.spacing(3),
  //     color: '#757575',
  //   },
  //      link: {
  //     display: 'inline-block',
  //     textTransform: 'uppercase',
  //     color: theme.palette.info.main,
  //     letterSpacing: 0.4,
  //     fontSize: 14,
  //     //marginLeft: theme.spacing(1),
  //     //fontWeight: 600,
  //     margin: `0 ${theme.spacing(3)}px 0 0`,
  //   },
  //   gridPaper: {
  //   padding: theme.spacing(1, 2, 2, 2),
  //   boxShadow: theme.shadows[0],
  // },
  // value: {
  //   fontSize: 34,
  //   marginBottom: theme.spacing(1),
  // },
  submitBtn: {
    fontSize: 12,
    whiteSpace: 'nowrap',
    fontWeight: 500,
    lineHeight: '26px',
    color: 'black',
    '&:hover': {
      color: 'black',
    },
  },
  icon: {
    color: 'green',
    position: 'absolute',
    fontSize: 40,
    zIndex: 1,
    top: 0,
    right: 0,
    transform: 'translate(52%, -48%)',
  },
  cardContainer: {
    position: 'relative',
    margin: '10px',
    // maxWidth: '300px',
    // display: 'flex',
    // justifyContent: 'center',
  },
  cardWrapper: {
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    cursor: 'pointer',
    maxWidth: '300px',
    width: '100%',
  },
  logoImage: {
    width: '80%',
    height: 'auto',
    maxHeight: '150px',
    objectFit: 'contain',
  },
  EndlogoImage: {
    width: '80%',
    height: '76px',
    maxHeight: '150px',
    objectFit: 'contain',
  },
  leftCol: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '24px',
    position: 'relative',
  },
  cardContent: {
    flex: '1',
    display: 'flex',
    alignItem: 'center',
    justifyContent: 'center',
  },
  card: {
    position: 'relative',
    borderRadius: '18px',
    padding: '10px',
    height: '180px',
    cursor: 'default',
    transition: '0.3s',
    border: '1px solid #e5e7eb',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  },
  clickableCard: {
    cursor: 'pointer',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
    },
  },
  oidcIcon: {
    position: 'absolute',
    left: 10,
    top: 10,
    width: 22,
    height: 22,
    borderRadius: '50%',
    background: '#ecfdf5',
    color: '#16a34a',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      fontSize: 15,
    },
  },
  approvedCard: {
    borderTop: '4px solid #22c55e',
  },
  noAccessCard: {
    borderTop: '4px solid #9ca3af',
    opacity: 0.85,
  },
  topIcon: {
    position: 'absolute',
    top: 16,
    right: 16,
    fontSize: 28,
  },
  approvedIcon: {
    color: '#22c55e',
  },
  deniedIcon: {
    color: '#9ca3af',
  },
  pendingIcon: {
    color: '#f59e0b',
  },
  appRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '18px',
    marginTop: '25px',
  },
  appIcon: {
    width: '58px',
    height: '58px',
    objectFit: 'contain',
  },
  appInitial: {
    width: '58px',
    height: '58px',
    borderRadius: '12px',
    background: '#eef2ff',
    color: '#3730a3',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    fontWeight: 700,
  },
  appName: {
    fontWeight: 700,
    fontSize: '20px',
    color: '#111827',
  },
  appDesc: {
    color: '#6b7280',
    fontSize: '14px',
    marginTop: '6px',
  },
  requestBtn: {
    marginTop: '22px',
    borderRadius: '10px',
    textTransform: 'none',
  },
}));
